import styled from "styled-components";
import colors from "../../../../config/colors";
import fonts from "../../../../config/fonts";
import { isMobile } from "../../../../utils/common";

export const FooterContainer = styled.div`
  width: 100vw;
  box-sizing: border-box;
`;

export const SubscriberSection = styled.div`
  background-color: ${colors.darkPrimary}C9;
  color: ${colors.background};
  padding: ${isMobile() ? "30px" : "60px"};
  display: flex;
  flex-direction: ${isMobile() ? "column" : "row"};
  align-items: center;
  justify-content: space-between;
`;
export const SubscribeTexts = styled.div`
  text-align: ${isMobile() ? "center" : "left"};
  margin-bottom: ${isMobile() ? "30px" : "0px"};
`;
export const SubscribeHeading = styled.div`
  ${fonts.headings};
  font-size: 35px;
  font-weight: bold;
  margin-bottom: 50px;
  ${
    isMobile() && `
      text-align:center;
      font-size:24px;
    `
  }
`;
export const SubscribeText = styled.div`
  ${fonts.text};
  font-size: 16px;
`;
export const MarketingContainer = styled.div`
  background-color: ${colors.darkPrimary};
  color: ${colors.background};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${isMobile()?"30px":"30px 100px"};
  flex-direction:${isMobile()?"column":"row"};
`;

export const TermsOfServiceOpener = styled.div`
  text-decoration:underline;
  cursor:pointer;
`;
export const PoweredBy = styled.div`
${isMobile() && `
  margin-top:30px;
`}
  text-align:center;
`;

export const Socials = styled.div`
  display: flex;
  ${isMobile() && `
    margin-top:30px;
  `}
`;
export const Email = styled.img`
  height: 25px;
  margin-right: 20px;
  :hover {
    cursor: pointer;
  }
`;
export const Reddit = styled.img`
  height: 25px;
  margin-right: 20px;
  :hover {
    cursor: pointer;
  }
`;
export const Twitter = styled.img`
  height: 25px;
  :hover {
    cursor: pointer;
  }
`;
